<template>
  <v-form @submit.prevent="doSubmit" ref="form" v-model="validForm" lazy-validation>
    <v-row>
      <v-col cols="12" sm="6">
        <v-card outlined class="mb-0">
          <v-card-title class="subtitle-1 font-weight-bold grey lighten-4 py-3 px-4">
            <v-icon left small>mdi-file-document-outline</v-icon>
            Datos de la cotización
          </v-card-title>
          <v-card-text class="pt-4">
            <v-text-field
                outlined label="Nombres" append-icon="mdi-account"
                v-model="cotizacion.nombres" readonly hide-details="auto" class="mb-4"
            ></v-text-field>
            <v-text-field
                outlined label="Apellidos" append-icon="mdi-account"
                v-model="cotizacion.apellidos" readonly hide-details="auto" class="mb-4"
            ></v-text-field>
            <v-text-field
                outlined label="Email" append-icon="mdi-email"
                v-model="cotizacion.email" readonly hide-details="auto" class="mb-4"
            ></v-text-field>
            <v-text-field
                outlined label="Número de celular" append-icon="mdi-cellphone"
                v-model="cotizacion.celular" readonly hide-details="auto" class="mb-4"
            ></v-text-field>
            <v-text-field
                outlined label="Sección" append-icon="mdi-office-building"
                :value="seccionNombre" readonly hide-details="auto" class="mb-4"
            ></v-text-field>
            <v-text-field
                outlined label="Precio" append-icon="mdi-currency-usd"
                v-model="cotizacion.precio" readonly hide-details="auto" class="mb-4"
            ></v-text-field>
            <v-text-field
                outlined label="Cupón de descuento" append-icon="mdi-ticket-percent"
                :value="cotizacion.cupon_descuento || 'Sin cupón'" readonly hide-details="auto" class="mb-4"
            ></v-text-field>
            <v-text-field
                outlined label="Estado" append-icon="mdi-information"
                v-model="cotizacion.estado" readonly hide-details="auto" class="mb-4"
            ></v-text-field>
            <v-text-field
                outlined label="Cuotas" append-icon="mdi-cash-multiple"
                :value="cotizacion.payments && cotizacion.payments.length ? cotizacion.payments : 'Al contado'"
                readonly hide-details="auto"
            ></v-text-field>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6">
        <v-card outlined>
          <v-card-title class="subtitle-1 font-weight-bold grey lighten-4 py-3 px-4">
            <v-icon left small>mdi-school-outline</v-icon>
            Datos para la matrícula
          </v-card-title>
          <v-card-text class="pt-4">
            <v-select
                label="Tipo de documento"
                v-model="formData.tipo_documento"
                :items="tiposDocumento"
                outlined
                item-text="nombre_largo"
                :rules="[rules.required]"
                return-object
                @change="validateDniLength"
                hide-details="auto"
                class="mb-4"
            ></v-select>
            <v-text-field
                outlined
                label="Número de documento"
                append-icon="mdi-badge-account-horizontal"
                v-model="formData.documento"
                :rules="[rules.required, rules.equalToLength(formData.tipo_documento ? formData.tipo_documento.tamanio_permitido : 8)]"
                ref="documento"
                hide-details="auto"
                class="mb-4"
            ></v-text-field>
            <v-card outlined class="card-vouchers mb-4">
              <v-card-subtitle class="pb-1">Foto de documento de identidad</v-card-subtitle>
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6" v-if="photoImgSrc">
                    <v-badge color="error" overlap style="width: 100%;">
                      <template v-slot:badge>
                        <v-icon @click="removeDni()">mdi-minus</v-icon>
                      </template>
                      <BaseImageViewer :imageSrc="photoImgSrc" />
                    </v-badge>
                  </v-col>
                  <v-col cols="12" sm="6" class="d-flex align-center" v-if="dniPhotos.length < 1">
                    <label for="file-input-dni" class="d-flex justify-center align-center upload-button">
                      <v-icon>mdi-plus</v-icon>
                    </label>
                    <input
                        id="file-input-dni"
                        type="file"
                        accept="image/*"
                        @change="onFileChangeDni"
                        ref="fileInputDni"
                        class="d-none"
                    >
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <v-menu
                v-model="dateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="dateFormatted"
                    label="Fecha de nacimiento"
                    append-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    :rules="[rules.required]"
                    readonly
                    hide-details="auto"
                    class="mb-4"
                ></v-text-field>
              </template>
              <v-date-picker
                  v-model="formData.fecha_nacimiento"
                  @input="dateMenu = false"
              ></v-date-picker>
            </v-menu>
            <v-autocomplete
                :items="departments"
                item-value="id"
                item-text="name"
                outlined
                v-model="formData.region"
                label="Región"
                :rules="[rules.required]"
                hide-details="auto"
                class="mb-4"
            />
            <v-autocomplete
                :items="instituciones"
                item-text="nombre"
                item-value="id"
                :rules="[rules.required]"
                outlined
                label="Universidad de estudio"
                append-icon="mdi-office-building"
                v-model="formData.institucion"
                return-object
                hide-details="auto"
                class="mb-4"
            ></v-autocomplete>
            <v-combobox
                v-model="formData.grados_formacion"
                :items="grados"
                item-text="nombre"
                item-value="id"
                chips
                clearable
                label="Grados de formación"
                multiple
                outlined
                :rules="[v => (v && v.length > 0) || 'Seleccione al menos un grado']"
                hide-details="auto"
                class="mb-4"
            >
              <template v-slot:selection="{ attrs, item, select, selected }">
                <v-chip v-bind="attrs" :input-value="selected" close @click="select" @click:close="removeGrado(item)">
                  <strong>{{ item.nombre }}</strong>&nbsp;
                </v-chip>
              </template>
            </v-combobox>
            <v-combobox
                v-model="formData.canales_referencia"
                :items="canales"
                item-text="nombre"
                item-value="id"
                chips
                clearable
                label="Canales de referencia"
                multiple
                outlined
                :rules="[v => (v && v.length > 0) || 'Seleccione al menos un canal']"
                hide-details="auto"
                class="mb-4"
            >
              <template v-slot:selection="{ attrs, item, select, selected }">
                <v-chip v-bind="attrs" :input-value="selected" close @click="select" @click:close="remove(item)">
                  <strong>{{ item.nombre }}</strong>&nbsp;
                </v-chip>
              </template>
            </v-combobox>
            <v-text-field
                outlined
                label="Número de carnet CMP (Opcional)"
                append-icon="mdi-badge-account"
                v-model="formData.carnet_cmp"
                autocomplete="off"
                :rules="[rules.maxLength(8)]"
                hide-details="auto"
                class="mb-4"
            ></v-text-field>
            <div class="full-width text-right mt-2">
              <v-btn
                  color="success"
                  :loading="saveLoading"
                  type="submit"
                  style="text-transform: none"
              >
                <v-icon left>mdi-school</v-icon>
                Matricular
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { required, equalToLength, maxLength } from '@/utils/rules'
import BaseImageViewer from '@/components/commonComponents/BaseImageViewer'

export default {
  name: 'TheCotizacionForm',
  components: { BaseImageViewer },
  props: {
    cotizacion: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      saveLoading: false,
      dateMenu: false,
      validForm: false,
      formData: {
        tipo_documento: null,
        documento: '',
        fecha_nacimiento: '',
        region: null,
        institucion: null,
        grados_formacion: [],
        canales_referencia: [],
        carnet_cmp: ''
      },
      dniPhotos: [],
      tiposDocumento: [],
      instituciones: [],
      regions: [],
      grados: [],
      canales: [],
      secciones: [],
      rules: { required, equalToLength, maxLength }
    }
  },
  computed: {
    dateFormatted() {
      return this.formatDate(this.formData.fecha_nacimiento)
    },
    departments() {
      return this.regions.filter(item => item.country.id === 10 || item.name === 'México')
    },
    photoImgSrc() {
      if (!this.dniPhotos.length) return null
      if (typeof this.dniPhotos[0] === 'string') return this.dniPhotos[0]
      return URL.createObjectURL(this.dniPhotos[0])
    },
    seccionNombre() {
      if (!this.cotizacion || !this.cotizacion.seccion) return ''
      const found = (this.secciones || []).find(s => s.id === this.cotizacion.seccion)
      return found ? found.nombre : String(this.cotizacion.seccion)
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${year}-${month}-${day}`
    },
    removeDni() {
      this.dniPhotos = []
    },
    onFileChangeDni(e) {
      const file = e.target.files[0]
      if (!file) return
      this.dniPhotos = [file]
    },
    removeGrado(item) {
      const idx = this.formData.grados_formacion.indexOf(item)
      if (idx > -1) {
        this.formData.grados_formacion.splice(idx, 1)
        this.formData.grados_formacion = [...this.formData.grados_formacion]
      }
    },
    remove(item) {
      const idx = this.formData.canales_referencia.indexOf(item)
      if (idx > -1) {
        this.formData.canales_referencia.splice(idx, 1)
        this.formData.canales_referencia = [...this.formData.canales_referencia]
      }
    },
    validateDniLength() {
      this.$nextTick(() => {
        if (this.$refs.documento) this.$refs.documento.validate()
      })
    },
    validateDocumentType() {
      if (!this.formData.tipo_documento) return 'El tipo de documento es requerido'
      return null
    },
    validateDocumento() {
      const tipo = this.formData.tipo_documento
      const value = (this.formData.documento || '').trim()
      if (!value) return 'El número de documento es requerido'
      if (!tipo) return 'Primero selecciona el tipo de documento'
      const id = tipo.id
      if (id === 1) {
        if (!/^\d{8}$/.test(value)) return 'El DNI debe tener exactamente 8 dígitos numéricos'
      } else if (id === 2) {
        if (!/^[a-zA-Z0-9]{8,20}$/.test(value)) return 'El CE debe tener entre 8 y 20 caracteres alfanuméricos'
      } else if (id === 3) {
        if (!/^[a-zA-Z0-9]{6,20}$/.test(value)) return 'El pasaporte debe tener entre 6 y 20 caracteres alfanuméricos'
      }
      return null
    },
    validateFoto() {
      const file = this.dniPhotos[0]
      if (!file) return 'La foto del documento de identidad es requerida'
      if (typeof file !== 'string') {
        const allowed = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp']
        if (!allowed.includes(file.type)) return 'El archivo debe ser una imagen (JPG, PNG o WEBP)'
        if (file.size > 5 * 1024 * 1024) return 'La imagen no debe superar los 5MB'
      }
      return null
    },
    validateFechaNacimiento() {
      const date = this.formData.fecha_nacimiento
      if (!date) return 'La fecha de nacimiento es requerida'
      const [year, month, day] = date.split('-').map(Number)
      const d = new Date(year, month - 1, day)
      if (d.getFullYear() !== year || d.getMonth() !== month - 1 || d.getDate() !== day) {
        return 'La fecha ingresada no es válida'
      }
      if (d > new Date()) return 'La fecha de nacimiento no puede ser futura'
      return null
    },
    validateRegion() {
      if (!this.formData.region) return 'La región es requerida'
      return null
    },
    validateInstitucion() {
      if (!this.formData.institucion) return 'La universidad de estudio es requerida'
      return null
    },
    validateGrados() {
      if (!this.formData.grados_formacion || !this.formData.grados_formacion.length) {
        return 'Debes seleccionar al menos un grado de formación'
      }
      return null
    },
    validateCanales() {
      if (!this.formData.canales_referencia || !this.formData.canales_referencia.length) {
        return 'Debes seleccionar al menos un canal de referencia'
      }
      return null
    },
    validateAll() {
      const errors = [
        this.validateDocumentType(),
        this.validateDocumento(),
        this.validateFoto(),
        this.validateFechaNacimiento(),
        this.validateRegion(),
        this.validateInstitucion(),
        this.validateGrados(),
        this.validateCanales(),
      ].filter(Boolean)
      return errors
    },
    async fetchInstituciones() {
      const res = await this.$http.get('api/instituciones/')
      this.instituciones = res.data
    },
    async fetchCanales() {
      const res = await this.$http.get('api/matriculas/canales_referencia/')
      this.canales = res.data
    },
    async fetchSecciones() {
      const res = await this.$http.get('api/matriculas/secciones/')
      this.secciones = res.data
    },
    async fetchCities() {
      const res = await this.$http.get('api/ciudades/region/')
      this.regions = res.data
    },
    async fetchGrados() {
      const res = await this.$http.get('api/matriculas/grados_formacion/')
      this.grados = res.data
    },
    async fetchTiposDocumento() {
      const res = await this.$http.get('api/tipos_documento/')
      this.tiposDocumento = res.data
    },
    async doSubmit() {
      // 1. Validar campos Vuetify
      if (!this.$refs.form.validate()) {
        await this.$root.$confirm({
          title: 'Campos incompletos',
          message: 'Asegúrese de llenar correctamente todos los campos.'
        })
        return
      }
      // 2. Validaciones adicionales
      const errors = this.validateAll()
      if (errors.length) {
        await this.$root.$confirm({
          title: 'Campos incompletos',
          message: errors.join('<br>')
        })
        return
      }
      // 3. Modal de confirmación
      const confirmed = await this.$root.$confirm({
        title: '¿Confirmar matrícula?',
        message: `¿Estás seguro de matricular a <strong>${this.cotizacion.nombres} ${this.cotizacion.apellidos}</strong>?`,
        acceptText: 'Sí, matricular',
        cancelText: 'Cancelar'
      })
      if (!confirmed) return
      // 4. Enviar
      try {
        this.saveLoading = true
        const payload = new FormData()
        payload.append('cotizacion', this.cotizacion.id)
        payload.append('seccion', this.cotizacion.seccion)
        payload.append('nombres', this.cotizacion.nombres)
        payload.append('apellidos', this.cotizacion.apellidos)
        payload.append('tipo_documento', this.formData.tipo_documento.id)
        payload.append('documento', this.formData.documento.trim())
        payload.append('fecha_nacimiento', this.formatDate(this.formData.fecha_nacimiento))
        payload.append('region', this.formData.region)
        payload.append('institucion', this.formData.institucion.id)
        this.formData.grados_formacion.forEach(g => payload.append('grados_formacion', g.id))
        this.formData.canales_referencia.forEach(c => payload.append('canales_referencia', c.id))
        if (this.formData.carnet_cmp) payload.append('carnet_cmp', this.formData.carnet_cmp)
        payload.append('foto_documento_identidad', this.dniPhotos[0])

        await this.$http.post('api/cotizador/inscripcion/', payload)
        await this.$root.$confirm({
          title: '¡Éxito!',
          message: 'Matrícula creada correctamente.'
        })
        this.$router.push({ name: 'Cotizaciones' })
      } catch (e) {
        let message = 'Ha ocurrido un error inesperado. Inténtelo de nuevo.'
        if (e.response && e.response.data) {
          const d = e.response.data
          message = typeof d === 'object'
            ? Object.values(d).flat().join('<br>')
            : String(d)
        }
        await this.$root.$confirm({
          title: '¡Ups!',
          message
        })
      } finally {
        this.saveLoading = false
      }
    }
  },
  async created() {
    await Promise.all([
      this.fetchCanales(),
      this.fetchSecciones(),
      this.fetchInstituciones(),
      this.fetchCities(),
      this.fetchGrados(),
      this.fetchTiposDocumento()
    ])
  }
}
</script>

<style scoped>
</style>
